var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vc-base-list-item",class:_vm.getListItemClasses,attrs:{"data-qa":_vm.dataQa},on:{"click":function($event){return _vm.onClick()}}},[[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }